













import { defineComponent, PropType } from "@vue/composition-api";
import { Story } from "@scrile/api-provider/dist/projects/scrileConnect/StoriesProvider";
import InfiniteScroll from "@/components/InfiniteScroll";
import StoriesArchiveCard from "./StoriesArchiveCard.vue";

export default defineComponent({
  name: "StoriesArchiveGrid",
  components: { InfiniteScroll, StoriesArchiveCard },
  props: {
    enableScroll: { type: Boolean, default: false },
    stories: { type: Array as PropType<Story[]>, required: true },
  },
});
